<template>
	<div class="hunterInfor">
		<div class="card">
			<div class="card-header" style="background: none; font-size: 20px; font-weight: bold; line-height: 40px;">模板列表
				<el-button type="primary" style=" float: right; width: auto; margin: 0;" @click="add_template">添加模板</el-button>
			</div>
			<div class="card-body">
				<div class="">
					<el-table :data="template_list" style="width: 100%">
						<el-table-column label="ID" align="center" min-width="30%">
							<template slot-scope="scope">
								<div>{{ scope.row.id }}</div>
							</template>
						</el-table-column>
						<el-table-column label="图片" align="center">
							<template slot-scope="scope">
								<div>
									<!-- {{ scope.row.image }} -->
									<img :src="scope.row.image" style="width: 50px; height: 50px;" />
								</div>
							</template>
						</el-table-column>
						<el-table-column label="添加日期" align="center">
							<template slot-scope="scope">
								<span>{{ scope.row.updated_at }}</span>
							</template>
						</el-table-column>
						<el-table-column label="删除日期" align="center">
							<template slot-scope="scope">
								<span>{{ scope.row.deleted_at }}</span>
							</template>
						</el-table-column>
						<el-table-column fixed="right" label="操作" width="100" align="center">
							<template slot-scope="scope">
								<el-button :disabled="scope.row.deleted_at!=''" @click="template_update(scope.row,$event)" type="text" size="small">修改</el-button>
								<el-button :disabled="scope.row.deleted_at!=''" @click="template_del(scope.row,$event)" type="text" size="small">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
		<!-- 分页 -->
		<pading :help="help_num" :currentPage = "currentPage" :pageSize="pageSize" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></pading>
		<!-- 分页 -->
	</div>
</template>

<script>
	import {
		templateList,
		templateDelete
	} from '../../common/api/http.js'
	import Pading from '../../components/paging/index.vue' //分页组件
	export default{
		components:{
			Pading
		},
		data(){
			return{
				template_list: [],
				
				help_num: 1,//总共多少条内容 默认1
				currentPage:1, //当前页的index
				pageSize:10, //每页显示多少条
			}
		},
		mounted() {
			// 模板列表
			this.templateDate()
			// 模板列表
		},
		methods:{
			// 模板列表-修改
			template_update(e,event){
				// console.log(e.id)
				this.$router.push({
					path: '/settings/templateShow',
					query: {
						id:e.id,
						modify:true
					}
				});
			},
			// 模板列表-删除
			template_del(e,event){
				let token = window.sessionStorage.getItem('token')
				templateDelete({
					'api_token': token,
					'id':e.id
				}).then(res => {
					console.log(res)
					if(res.code==0){
						this.templateDate()
						this.$message({
						  message: '删除成功!',
						  type: 'success'
						});
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//添加模板
			add_template(e){
				this.$router.push({
					path: '/settings/templateShow',
					query: {
						marking:true
					}
				});
			},
			// 每页显示条数 10，20，50，100
			handleSizeChange(val) {
				// console.log(`每页 ${val} 条`);
				this.pageSize = val
				this.templateDate()
			},
			//当前页的index
			handleCurrentChange(val) {
				// console.log(`当前页: ${val}`);
				this.currentPage = val
				this.templateDate()
			},
			// 模板列表
			templateDate(){
				let token = window.sessionStorage.getItem('token')
				templateList({
					'api_token': token,
					'page':this.currentPage,
					'page_size':this.pageSize
				}).then(res => {
					// console.log(res)
					if(res.code==0){
						this.template_list = res.data.template_list
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style lang="less">
	.hunterInfor {
		margin-top: 20px;
	}
</style>
